import { newDeck } from "../helpers/gameHelpers";
import type { Game, GameConfigParams } from "./types";

export const createConfiguredGame = (
  game: Game,
  args: GameConfigParams = {},
  now: number = Date.now(),
): Game => {
  const { courts, players, perCourt, shortCourt } = { ...game, ...args };

  return {
    slug: game.slug,
    cards: newDeck({ courts, players, perCourt, shortCourt }),
    courts,
    players,
    perCourt,
    roundId: game.roundId,
    shortCourt,
    lastDrawn: -1,
    syncStatus: game.syncStatus,
    updatedAt: now,
  };
};
